import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ZkNotificationService } from '@zenklub/ng-ui';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { IProfessionalAddress } from 'app/interfaces/address.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { AddressService } from 'app/services/address.service';

@Component({
	selector: 'onsite-sessions',
	templateUrl: './onsite-sessions.component.html',
	styleUrls: ['./onsite-sessions.component.scss'],
})
export class OnsiteSessions implements OnInit {
	isError = false;
	isLoading = true;
	addresses: IProfessionalAddress[] = [];

	constructor(
		private router: Router,
		private actionTrackerService: ActionTrackerService,
		private addressService: AddressService,
		public notifications: ZkNotificationService,
		private translateService: TranslateService
	) {}

	ngOnInit() {
		this.addressService.getAddresses().subscribe({
			next: (data) => {
				this.addresses = data;
				this.isLoading = false;
			},
			error: (error) => {
				this.isLoading = false;

				if (error.status === 404) {
					this.addresses = [];
				} else {
					this.isError = true;
					console.error(error);
					this.notifications.showError(
						this.translateService.instant(
							'MY_ACCOUNT.ONSITE_SESSIONS.ERRORS.FETCH_ADDRESSES'
						)
					);
				}
			},
		});
	}

	goToAddressForm() {
		this.actionTrackerService.eventTracker(
			SCOPE_TYPE.Account,
			SUBSCOPE_TYPE.Address,
			ITEM_TYPE.Link,
			INTERACTION_TYPE.Click
		);
		this.router.navigateByUrl('/account/address/new');
	}

	showNewAddressButton() {
		return this.addresses.length < 3;
	}

	onRemovedAddress(id: string) {
		this.addresses = this.addresses.filter((address) => address.id !== id);
	}
}
